import { LessonDto } from "./LessonDto";

export class CourseModuleDto{
    id!:string;
    title!:string;
    courseId!:string;
    order!:number;
    isActive!:boolean;
    description!:string;
    lessons!:LessonDto[];
}
export class CourseModuleCreateDto{
    order!:number;
    title!:string;
    courseId!:string;
    description!:string;
}